/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import moment from "moment";
import { Card, CardBody, CardHeader } from "reactstrap";
import { PedidoFilters } from "../components/Pedido.Filtes";
import { useEmpaque } from "../hooks/useEmpaque";
import { useEffect, useState } from "react";
import { PedidoTable } from "../components/Pedido.Table";
import { AddPedido } from "../components/Add.Pedido";
import { EditarPedido } from "../components/Edit.Pedido";
import Swal from "sweetalert2";
import { useSize } from "../../../hooks/useSize";
import { useProgramacion } from "../../programacion-empaque/hooks/useProgramacion";
import { programacionkey } from "../constants/Empaque.Constants";
import { useNavigate } from "react-router-dom";
import { SkeletonTable } from "../../../components/Skeleton.Table";

const initialValues = {
  id_cultivo: "",
  fecha: moment().add(1, "days").format("YYYY-MM-DD"),
  id_variedad: "",
};

const empaqueFormInitialValues = {
  id_diaria: 0,
  id_variedad: 0,
  variedad: "",
  tamanios: [],
  variedadesOptions: [],
  id_campo: 0,
  campo: "",
};

export const PedidoEmpaque = () => {
  const { getPedidoEmpaque } = useEmpaque();
  const { getSize } = useSize();
  const { getProgramacion } = useProgramacion();
  const navigate = useNavigate();
  const [size, setSize] = useState([]);
  const [pedidoData, setPedidoData] = useState([]);
  const [bicolor, setBicolor] = useState(false);
  const [isAddVisible, setIsAddVisible] = useState(false);
  const [idPedido, setIdPedido] = useState(0);
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { values, handleChange, setFieldValue } = useFormik({
    onSubmit: () => {},
    initialValues,
  });

  const empaqueForm = useFormik({
    onSubmit: () => {},
    initialValues: empaqueFormInitialValues,
  });

  const reloadOnSave = () => {
    getPedido();
    setIsAddVisible(false);
    setIsEditVisible(false);
  };

  const handleBicolorClick = (id_campo, campo) => {
    const totalTamanios = getTamaniosOptionsBicolor(id_campo);
    const variedadOptions = getVariedadesOptionsBicolor(id_campo);

    setBicolor(true);
    empaqueForm.setValues({
      ...empaqueForm.values,
      id_campo: id_campo,
      campo: campo,
      variedad: "BICOLOR",
      tamanios: totalTamanios,
      variedadesOptions: variedadOptions,
    });
    setTimeout(() => {
      setIsAddVisible(true);
    }, 200);
  };

  const getTamaniosOptionsBicolor = (id_campo) => {
    const tamanios = {};
    const campo = pedidoData.find((item) => item.id_campo === id_campo);
    if (campo) {
      campo.variedades.forEach((variedad) => {
        variedad.tamanos.forEach((tamano) => {
          if (!tamanios[tamano.tamanio]) {
            tamanios[tamano.tamanio] = 0;
          }
          tamanios[tamano.tamanio] += tamano.total;
        });
      });
    }

    const totalTamanios = size.map((tamanio) => ({
      tamanio: tamanio.tamano,
      total: tamanios[tamanio.tamano],
    }));

    return totalTamanios;
  };

  const getVariedadesOptionsBicolor = (id_campo) => {
    const campo = pedidoData.find((item) => item.id_campo === id_campo);
    if (campo) {
      const variedad = campo.variedades.map((variedad) => ({
        id_diaria: variedad.id_diaria,
        id_variedad: variedad.id_variedad,
        variedad: variedad.variedad,
        tamanios: variedad.tamanos,
      }));
      return variedad;
    }
    return [];
  };

  const handleNewEmpaqueClick = (id_campo, id_variedad) => {
    const campo = pedidoData.find((item) => item.id_campo === id_campo);
    const variedad = campo.variedades.find(
      (item) => item.id_variedad === id_variedad,
    );

    const order_size = size.map((item) =>
      variedad.tamanos.find((tam) => tam.tamanio === item.tamano),
    );

    setBicolor(false);
    empaqueForm.setValues({
      ...empaqueForm.values,
      tamanios: order_size,
      id_variedad: id_variedad,
      id_diaria: variedad.id_diaria,
      variedad: variedad.variedad,
      id_campo: id_campo,
      campo: campo ? campo.campo : "",
    });

    setTimeout(() => {
      setIsAddVisible(true);
    }, 500);
  };

  const onCloseAddPedido = () => {
    setIsAddVisible(false);
    setBicolor(false);
    empaqueForm.resetForm();
  };

  const getPedido = async () => {
    setIsLoading(true);
    try {
      const response = await getPedidoEmpaque(values.fecha, values.id_variedad);
      setPedidoData(response);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const closeEditar = () => {
    setIdPedido(0);
    setIsEditVisible(false);
    empaqueForm.resetForm();
  };

  const onEditClick = (id_pedido, id_variedad) => {
    setIdPedido(id_pedido);
    setTimeout(() => {
      setIsEditVisible(true);
    }, 200);
  };

  useEffect(() => {
    if (values.fecha !== "") {
      getPedido();
    }
  }, [values.id_variedad, values.fecha]);

  useEffect(() => {
    const getTamanio = async () => {
      const response = await getSize(values.id_cultivo);
      setSize(response);
    };
    if (values.id_cultivo !== "") {
      getTamanio();
    }
  }, [values.id_cultivo]);

  useEffect(() => {
    const checkProgramacion = async () => {
      const fechaFormateada = moment(values.fecha).format("YYYY-MM-DD");
      const notification_display = localStorage.getItem(programacionkey);

      try {
        const response = await getProgramacion(
          values.fecha,
          values.id_cultivo,
          0,
        );
        if (response.length > 0 && notification_display !== fechaFormateada) {
          Swal.fire({
            icon: "info",
            title: "Programaciones de empaque pendientes por asignar",
            text: "Se han identificado programaciones de empaque correspondientes a la fecha y al cultivo seleccionados. ¿Desea revisarlas ahora?",
            showCancelButton: true,
            showConfirmButton: true,
            showDenyButton: true,
            cancelButtonText: "Recordar más tarde",
            confirmButtonText: "Sí",
            denyButtonText: "No",
            confirmButtonColor: "green",
          }).then((res) => {
            if (res.isConfirmed) {
              navigate(`/programacion?fecha=${fechaFormateada}`);
            }
            if (res.isDismissed) {
              localStorage.removeItem(programacionkey);
            } else {
              localStorage.setItem(programacionkey, fechaFormateada);
            }
          });
        }
        // else{
        //   localStorage.setItem(programacionkey, fechaFormateada);

        // }
      } catch (error) {
        console.error("Error obteniendo programaciones:", error);
      }
    };

    if (values.id_cultivo) {
      checkProgramacion();
    }
  }, [getProgramacion, values.fecha, values.id_cultivo, navigate]);

  return (
    <Card>
      <CardHeader>Pedido de empaque</CardHeader>
      <CardBody>
        <PedidoFilters
          values={values}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
        />
        <br />
        {isLoading ? (
          <SkeletonTable />
        ) : (
          <PedidoTable
            empaqueData={pedidoData}
            id_cultivo={values.id_cultivo}
            setEmpaqueData={setPedidoData}
            handleBicolorClick={handleBicolorClick}
            handleNewEmpaqueClick={handleNewEmpaqueClick}
            handleEditClick={onEditClick}
            reload={getPedido}
            fecha={values.fecha}
            updateOnSave={reloadOnSave}
          />
        )}
        <AddPedido
          bicolor={bicolor}
          id_campo={empaqueForm.values.id_campo}
          campo={empaqueForm.values.campo}
          fecha={values.fecha}
          variedad={empaqueForm.values.variedad}
          tamanios={empaqueForm.values.tamanios}
          variedadesOptions={empaqueForm.values.variedadesOptions}
          id_cultivo={values.id_cultivo}
          isVisible={isAddVisible}
          onClose={onCloseAddPedido}
          id_diaria={empaqueForm.values.id_diaria}
          id_variedad={empaqueForm.values.id_variedad}
          updateOnSave={reloadOnSave}
        />
        <EditarPedido
          id_pedido={idPedido}
          isVisible={isEditVisible}
          onClose={closeEditar}
          id_cultivo={values.id_cultivo}
          reload={reloadOnSave}
        />
      </CardBody>
    </Card>
  );
};
